const projectRoleStatuses = {
  active: { id: 'active', name: 'Active' },
  archived: { id: 'inactive', name: 'Inactive' },
};

export default projectRoleStatuses;
